// https://stackoverflow.com/questions/66389974/using-font-awesome-in-vue-3
// https://fontawesome.com/
// https://fontawesome.com/v6/search?m=free
// 以下引用fontawesome
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faTimes,
  faUndoAlt,
  faTrash,
  faMousePointer,
  faImage,
  faVideo,
  faShare,
  faDownload,
  faHome,
  faCalendarAlt,
  faMap,
  faUserSlash,
  faChevronRight,
  faBell,
  faBellSlash,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/scss/app.scss';

import * as globalComponents from './components/index';

const app = createApp(App);

// 引入global components
Object.entries(globalComponents).forEach(([key, value]) => {
  app.component(key, value);
});

// fontawesome library加入icon
library.add(faUndoAlt);
library.add(faTrash);
library.add(faMousePointer);
library.add(faImage);
library.add(faVideo);
library.add(faShare);
library.add(faDownload);
library.add(faHome);
library.add(faCalendarAlt);
library.add(faTimes);
library.add(faMap);
library.add(faUserSlash);
library.add(faChevronRight);
library.add(faBell);
library.add(faBellSlash);

app.component('FontAwesomeIcon', FontAwesomeIcon);

app.use(router).mount('#app');
